import * as actionTypes from "../constants/ActionTypes/PrintActivity";

export const GetPrintActivity = (UID, deviceId, IS_CSAGENT = false, customerCountryCode = null) => ({
    type: actionTypes.GET_PRINT_ACTIVITY_INIT,
    UID,
    deviceId,
    IS_CSAGENT,
    customerCountryCode
});

export const ResetPrintActivity = () => ({
    type: actionTypes.RESET_GET_PRINT_ACTIVITY
});